(function(){
  "use strict";
  var $  = function(s,c){ return (c||document).querySelector(s); };
  var $$ = function(s,c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); };
  var hasGSAP  = typeof window.gsap !== 'undefined';
  var hasST    = hasGSAP && typeof window.ScrollTrigger !== 'undefined';
  var hasSplit = hasGSAP && typeof window.SplitText !== 'undefined';
  var reduce   = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var isTouch  = ('ontouchstart' in window) || (navigator.maxTouchPoints>0);
  if(isTouch) document.body.classList.add('touch');
  var appBooted = window.__lateSeatingBooted === true;
  var sectionRegistry = Object.create(null);
  var crossContext = null;
  var crossTriggers = [];

  function sectionKey(root){
    return (root && (root.id || root.getAttribute('data-section-id'))) || '__document__';
  }
  function inRoot(root, selector){
    if(!root) return $(selector);
    if(root.matches && root.matches(selector)) return root;
    return $(selector, root);
  }
  function addCleanup(list, value){ if(typeof value === 'function') list.push(value); }

  function clamp(v,a,b){ return v<a?a:(v>b?b:v); }
  function lerp(a,b,t){ return a+(b-a)*t; }
  function pad(n){ return (n<10?'0':'')+n; }
  var vel = 0; window.__vel = 0;

  var E = {
    reveal:'expo.out',
    rise:'power4.out',
    soft:'power3.out',
    ember:'power1.inOut',
    inOut:'power2.inOut',
    pop:'back.out(2.2)'
  };

  if(hasGSAP && hasST){
    gsap.registerPlugin(ScrollTrigger);
    if(hasSplit){ try{ gsap.registerPlugin(SplitText); }catch(e){} }
    gsap.defaults({ ease:E.soft });
  }

  /* ───── PRELOADER (coals holding, <=2.5s) ───── */
  function runPreloader(done){
    var pre = $('#preloader');
    if(window.__lateSeatingBooted){ if(pre && pre.parentNode) pre.remove(); done(); return; }
    if(!pre){ done(); return; }
    var bar = $('#preBar'), temp = $('#preTemp'), state = $('#preState');
    var len = 0;
    if(bar && bar.getTotalLength){ try{ len = bar.getTotalLength(); bar.style.strokeDasharray = len; bar.style.strokeDashoffset = len; }catch(e){} }
    var doneOnce = false;
    function finish(){ if(doneOnce) return; doneOnce = true; pre.classList.add('done'); setTimeout(function(){ if(pre.parentNode) pre.remove(); done(); }, 640); }
    setTimeout(finish, 2900);
    if(reduce || !hasGSAP){
      if(temp) temp.innerHTML = '498&deg;C';
      if(state) state.textContent = 'Fire is held';
      if(bar && len) bar.style.strokeDashoffset = 0;
      finish(); return;
    }
    var obj = {v:0};
    var tl = gsap.timeline({ onComplete: finish });
    tl.to(obj, {v:1, duration:1.5, ease:'power2.inOut', onUpdate:function(){
      var p = obj.v;
      if(bar && len) bar.style.strokeDashoffset = (len*(1-p)).toFixed(1);
      var t = Math.round(lerp(21, 498, p));
      if(temp) temp.innerHTML = t + '&deg;C';
      if(state){
        if(p<0.4) state.textContent = 'Holding the coals';
        else if(p<0.82) state.textContent = 'Keeping the heat';
        else state.textContent = 'Fire is held';
      }
    }});
    tl.to('.pre-word', {letterSpacing:'0.44em', duration:0.6, ease:'power2.out'}, 0);
    tl.to({}, {duration:0.24});
  }

  /* ───── CANDLE CURSOR ───── */
  function initCursor(root){
    if(isTouch) return;
    var cur = inRoot(root,'.cursor'), dot = inRoot(root,'.cursor-dot');
    if(!cur||!dot) return;
    var mx=innerWidth/2, my=innerHeight/2, cx=mx, cy=my;
    var run=true;
    function move(e){
      mx=e.clientX; my=e.clientY;
      dot.style.transform='translate('+mx+'px,'+my+'px)';
    }
    window.addEventListener('mousemove', move, {passive:true});
    function raf(){ if(!run) return; cx += (mx-cx)*0.2; cy += (my-cy)*0.2; cur.style.transform='translate('+cx+'px,'+cy+'px)'; requestAnimationFrame(raf); }
    raf();
    return function(){ run=false; window.removeEventListener('mousemove',move); };
  }

  function bindCursor(root){
    if(isTouch || window.__lateSeatingCursorDelegated) return;
    window.__lateSeatingCursorDelegated=true;
    document.addEventListener('mouseover',function(event){
      if(event.target.closest && event.target.closest('[data-cursor],a,button')){ var cur=$('.cursor'); if(cur) cur.classList.add('on'); }
    });
    document.addEventListener('mouseout',function(event){
      if(event.target.closest && event.target.closest('[data-cursor],a,button')){ var cur=$('.cursor'); if(cur) cur.classList.remove('on'); }
    });
  }

  /* ───── NAV ───── */
  function initNav(root){
    var nav = inRoot(root,'#nav');
    if(!nav) return;
    function upd(){ var y = window.pageYOffset || document.documentElement.scrollTop; if(y>60) nav.classList.add('shrunk'); else nav.classList.remove('shrunk'); }
    upd(); window.addEventListener('scroll', upd, {passive:true});
    var burger = inRoot(root,'#burger');
    var drawer=inRoot(root,'#mobileNav');
    var panel=drawer?$('.mobile-nav__panel',drawer):null;
    var drawerOpen=false;
    function setDrawer(open,restoreFocus){
      if(!burger||!drawer) return;
      drawerOpen=open;
      drawer.classList.toggle('open',open);
      drawer.setAttribute('aria-hidden',open?'false':'true');
      burger.setAttribute('aria-expanded',open?'true':'false');
      burger.setAttribute('aria-label',open?'Close navigation':'Open navigation');
      document.body.classList.toggle('alia-nav-open',open);
      if(open){
        requestAnimationFrame(function(){ var closeBtn=$('.mobile-nav__close',drawer); if(closeBtn) closeBtn.focus(); });
      } else if(restoreFocus){
        burger.focus();
      }
    }
    function toggleDrawer(){ setDrawer(!drawerOpen,false); }
    function onDrawerClick(event){
      var closeTarget=event.target.closest&&event.target.closest('[data-nav-close]');
      var link=event.target.closest&&event.target.closest('[data-nav-link]');
      if(closeTarget||link) setDrawer(false,!!closeTarget);
    }
    function onDrawerKeydown(event){
      if(event.key==='Escape'){ event.preventDefault(); setDrawer(false,true); return; }
      if(event.key!=='Tab'||!drawerOpen||!panel) return;
      var focusable=$$('a[href],button:not([disabled])',panel).filter(function(el){ return el.offsetParent!==null; });
      if(!focusable.length) return;
      var first=focusable[0], last=focusable[focusable.length-1];
      if(event.shiftKey&&document.activeElement===first){ event.preventDefault(); last.focus(); }
      else if(!event.shiftKey&&document.activeElement===last){ event.preventDefault(); first.focus(); }
    }
    function onResize(){ if(window.innerWidth>1050&&drawerOpen) setDrawer(false,false); }
    if(burger) burger.addEventListener('click',toggleDrawer);
    if(drawer){
      drawer.addEventListener('click',onDrawerClick);
      drawer.addEventListener('keydown',onDrawerKeydown);
    }
    window.addEventListener('resize',onResize,{passive:true});
    return function(){
      setDrawer(false,false);
      window.removeEventListener('scroll',upd);
      window.removeEventListener('resize',onResize);
      if(burger) burger.removeEventListener('click',toggleDrawer);
      if(drawer){
        drawer.removeEventListener('click',onDrawerClick);
        drawer.removeEventListener('keydown',onDrawerKeydown);
      }
    };
  }

  /* ───── SMOOTH ANCHORS ───── */
  function scrollToEl(sel){
    var el = $(sel); if(!el) return;
    if(window.__lenis && window.__lenis.scrollTo){ window.__lenis.scrollTo(el,{offset:-4}); }
    else { el.scrollIntoView({behavior:reduce?'auto':'smooth'}); }
  }
  function bindAnchors(root){
    $$('a[href^="#"]',root).forEach(function(a){
      if(a.getAttribute('data-ls-anchor-bound')==='true') return;
      a.setAttribute('data-ls-anchor-bound','true');
      a.addEventListener('click', function(e){ var href=a.getAttribute('href'); if(href.length>1 && $(href)){ e.preventDefault(); scrollToEl(href); } });
    });
  }

  /* ───── REVEALS ───── */
  function initReveals(root){
    var els = $$('[data-reveal]',root);
    if(!hasGSAP || !hasST || reduce){ els.forEach(function(el){ el.style.opacity=1; el.style.transform='none'; }); return; }
    gsap.set(els, {opacity:0, y:30});
    if(els.length) ScrollTrigger.batch(els, { start:'top 88%', onEnter:function(b){ gsap.to(b,{opacity:1,y:0,duration:1.0,stagger:{each:0.09},ease:E.reveal}); } });
  }

  /* ───── HEADLINE MASK RISE ───── */
  function initHeadlines(root){
    if(!hasGSAP || !hasST || reduce) return;
    $$('[data-headline]',root).forEach(function(h){
      var parts=null;
      if(hasSplit){ try{ parts = new SplitText(h, {type:'lines', linesClass:'ln-inner'}); }catch(e){ parts=null; } }
      var targets = parts ? parts.lines : [h];
      if(parts){ parts.lines.forEach(function(l){ l.style.overflow='hidden'; l.style.display='block'; }); }
      gsap.set(targets, {yPercent:110});
      gsap.to(targets, { yPercent:0, duration:1.05, stagger:0.1, ease:E.rise, scrollTrigger:{ trigger:h, start:'top 90%' } });
    });
    /* embers title: scale + glow rise */
    var et = $('[data-embers-title]',root);
    if(et){ gsap.set(et,{opacity:0,scale:0.94,y:24}); gsap.to(et,{opacity:1,scale:1,y:0,duration:1.2,ease:E.reveal,scrollTrigger:{trigger:et,start:'top 84%'}}); }
  }

  /* ───── HERO INTRO ───── */
  function heroIntro(root){
    var spans = $$('#heroH1 .ln>span',root);
    if(!spans.length) return;
    if(reduce || !hasGSAP){ return; }
    gsap.set(spans, {yPercent:118});
    var tl = gsap.timeline({ defaults:{ ease:E.soft } });
    tl.from($('.hero-eyebrow',root), {opacity:0, y:16, duration:0.7}, 0.15)
      .to(spans, {yPercent:0, duration:1.25, stagger:0.13, ease:E.rise}, 0.3)
      .from($('.hero-sub',root), {opacity:0, y:24, duration:0.9, ease:E.reveal}, 1.0)
      .from($('.hero-actions',root), {opacity:0, y:20, duration:0.85, ease:E.reveal}, 1.15)
      .from($('.hero-foot',root), {opacity:0, y:20, duration:0.85, ease:E.reveal}, 1.3)
      .from($('.hero-scroll',root), {opacity:0, duration:0.7}, 1.5);
    if(!reduce){
      gsap.to($('.hero-scroll .rail i',root), {y:30, duration:1.4, repeat:-1, ease:'power1.inOut', yoyo:true});
    }
  }

  /* ───── HERO EMBER CANVAS (calm, slow-rising, IO-gated, DPR<=2) ───── */
  function initHeroCanvas(root){
    var cv = inRoot(root,'#heroEmber');
    if(!cv || reduce) return;
    var ctx = cv.getContext && cv.getContext('2d');
    if(!ctx) return;
    var dpr = Math.min(window.devicePixelRatio||1, 2), sparks=[];
    function size(){ var r=cv.getBoundingClientRect(); cv.width=Math.max(2,Math.round(r.width*dpr)); cv.height=Math.max(2,Math.round(r.height*dpr)); build(); }
    function build(){ var W=cv.width, H=cv.height; var n=clamp(Math.round((W*H)/(78000*dpr)),12,44); sparks=[]; for(var i=0;i<n;i++) sparks.push(spark(W,H,true)); }
    function spark(W,H,init){ return { x:Math.random()*W, y:init?Math.random()*H:H+8, r:(Math.random()*1.4+0.5)*dpr, vy:(-Math.random()*0.26-0.09)*dpr, vx:(Math.random()-0.5)*0.1*dpr, a:Math.random()*0.42+0.16, tw:Math.random()*6.28 }; }
    var run=false;
    function frame(){ if(!run) return; var W=cv.width, H=cv.height; ctx.clearRect(0,0,W,H);
      for(var i=0;i<sparks.length;i++){ var s=sparks[i]; s.x+=s.vx; s.y+=s.vy; s.tw+=0.04;
        if(s.y<-8){ sparks[i]=spark(W,H,false); continue; }
        var fl=(0.55+0.45*Math.sin(s.tw))*s.a;
        var g=ctx.createRadialGradient(s.x,s.y,0,s.x,s.y,s.r*3.4);
        g.addColorStop(0,'rgba(255,255,255,'+fl+')'); g.addColorStop(0.5,'rgba(138,95,58,'+(fl*0.7)+')'); g.addColorStop(1,'rgba(138,95,58,0)');
        ctx.fillStyle=g; ctx.beginPath(); ctx.arc(s.x,s.y,s.r*3.4,0,6.2832); ctx.fill();
      }
      requestAnimationFrame(frame);
    }
    function start(){ if(run)return; run=true; requestAnimationFrame(frame); }
    function stop(){ run=false; }
    size();
    var rt, io=null;
    function resize(){ clearTimeout(rt); rt=setTimeout(size,220); }
    window.addEventListener('resize', resize, {passive:true});
    if('IntersectionObserver' in window){ io=new IntersectionObserver(function(en){ en.forEach(function(e){ e.isIntersecting?start():stop(); }); },{threshold:0.02}); io.observe(cv); } else start();
    return function(){ stop(); clearTimeout(rt); window.removeEventListener('resize',resize); if(io) io.disconnect(); };
  }

  /* ───── REAL SERVICE HOURS (Thu 19-01, Fri 19-02, Sat 19-02) ───── */
  function windowsAround(base){
    var list=[];
    for(var d=-1; d<=8; d++){
      var day=new Date(base); day.setDate(base.getDate()+d); day.setHours(0,0,0,0);
      var wd=day.getDay(), dur=0;
      if(wd===4) dur=6; else if(wd===5||wd===6) dur=7; else continue;
      var open=new Date(day); open.setHours(19,0,0,0);
      var close=new Date(open.getTime()+dur*3600000);
      list.push([open,close]);
    }
    return list;
  }
  function fmt12(d){ var h=d.getHours(), m=d.getMinutes(); var ap=h>=12?'PM':'AM'; var hr=h%12; if(hr===0) hr=12; return hr+':'+pad(m)+' '+ap; }

  /* ───── KITCHEN STATE CHIP + DOORS COUNTDOWN ───── */
  function initKitchen(root){
    var staticHero=inRoot(root,'#hero[data-static-readings]');
    if(staticHero) return;
    var chip=inRoot(root,'#stateText'), doors=inRoot(root,'#doorsRead'), last=inRoot(root,'#lastCall');
    if(!chip && !doors && !last) return;
    function tick(){
      var hudState=$('#hudState');
      var t=new Date(), wins=windowsAround(t), openNow=null, next=null;
      for(var i=0;i<wins.length;i++){ var w=wins[i];
        if(t>=w[0] && t<w[1]){ openNow=w; break; }
        if(t<w[0] && !next){ next=w; }
      }
      if(openNow){
        var rem=openNow[1]-t; var s=Math.floor(rem/1000); var h=Math.floor(s/3600); var m=Math.floor((s%3600)/60);
        if(chip) chip.innerHTML='Kitchen is open &middot; <b>last call '+fmt12(openNow[1])+'</b>';
        if(doors) doors.innerHTML='OPEN &middot; '+h+'H '+pad(m)+'M LEFT';
        if(last) last.textContent=fmt12(openNow[1]);
        if(hudState) hudState.textContent='open now';
      } else if(next){
        var ms=next[0]-t; var ss=Math.floor(ms/1000); var hh=Math.floor(ss/3600); var mm=Math.floor((ss%3600)/60); var s2=ss%60;
        if(chip) chip.innerHTML='Doors in <b>'+pad(hh)+':'+pad(mm)+':'+pad(s2)+'</b>';
        if(doors) doors.textContent=pad(hh)+':'+pad(mm)+':'+pad(s2);
        if(last) last.textContent=fmt12(next[1]);
        if(hudState) hudState.textContent='opens '+fmt12(next[0]);
      } else {
        if(chip) chip.textContent='Open late Thursday to Saturday';
        if(doors) doors.textContent='--:--:--';
      }
    }
    tick(); var interval=setInterval(tick, 1000);
    return function(){ clearInterval(interval); };
  }

  /* ───── THE LATE CLOCK · SET PIECE 1 ───── */
  function initClock(root){
    var pin=inRoot(root,'#clockPin'), stage=inRoot(root,'#clockStage');
    if(!pin||!stage) return;
    var hour=$('#clkHour'), minute=$('#clkMin'), arc=$('#clkArc'), nowDot=$('#clkNow'), center=$('#clkCenter');
    var elTime=$('#clkTime'), elState=$('#clkState'), elFull=$('#clkFull'), elPlates=$('#clkPlates');
    var elBeatTitle=$('#beatTitle'), elBeatSub=$('#beatSub'), elDish=$('#beatDish'), elDishDesc=$('#beatDishDesc');
    var elProg=$('#clkProg');
    var marks=$$('#clkLine span',root);
    if(nowDot){
      nowDot.style.removeProperty('transform');
      nowDot.style.removeProperty('transform-origin');
      nowDot.removeAttribute('transform');
    }

    /* build fine ticks */
    var ticks=$('#clkTicks');
    if(ticks){
      var ns='http://www.w3.org/2000/svg', frag=document.createDocumentFragment();
      for(var i=0;i<60;i++){
        var isHr=(i%5===0);
        var ln=document.createElementNS(ns,'line');
        ln.setAttribute('x1','200'); ln.setAttribute('y1', isHr?'22':'26');
        ln.setAttribute('x2','200'); ln.setAttribute('y2', isHr?'36':'32');
        ln.setAttribute('class', isHr?'clk-tick hr':'clk-tick');
        ln.setAttribute('transform','rotate('+(i*6)+' 200 200)');
        frag.appendChild(ln);
      }
      ticks.appendChild(frag);
    }

    /* arc length for reveal */
    var arcLen=250;
    if(arc && arc.getTotalLength){ try{ arcLen=arc.getTotalLength(); }catch(e){} }
    if(arc){ arc.style.strokeDasharray=arcLen; arc.style.strokeDashoffset=arcLen; }

    /* beats: minutes-from-11PM, room state, dish */
    var BEATS=marks.map(function(mark){ return {
      t:parseInt(mark.getAttribute('data-mark'),10)||0,
      time:mark.getAttribute('data-time')||mark.textContent,
      state:mark.getAttribute('data-state')||'',
      title:mark.getAttribute('data-title')||'',
      sub:mark.getAttribute('data-copy')||'',
      dish:mark.getAttribute('data-dish')||'',
      desc:mark.getAttribute('data-description')||''
    }; });
    if(!BEATS.length) BEATS=[
      {t:0,   time:'11:00 PM', state:'Second wave', title:'The second wave',
        sub:"Eleven o'clock. The tables turn over and the room refills with the late crowd. Scroll to hold the fire toward last call.",
        dish:'KOPANISTI', desc:'House smoked greek feta, roasted red and aleppo peppers, grilled pita.'},
      {t:30,  time:'11:30 PM', state:'Warming up', title:'Half past eleven',
        sub:'The music sits up a little. Cigars and prawns start coming off the fire for the middle of the table.',
        dish:'MOROCCAN CIGARS', desc:'Chili jam, aleppo honey, kosher-style. Five to a plate.'},
      {t:60,  time:'12:00 AM', state:'Deep room', title:'The deep room',
        sub:'Midnight. The room settles into itself. Lower light, longer tables, the night fully its own thing now.',
        dish:'BURRATA', desc:'Heirloom tomatoes, grilled peaches, balsamic glaze, champagne vinaigrette.'},
      {t:90,  time:'12:30 AM', state:'Full & low', title:'Half past midnight',
        sub:'The floor is full and the pace is easy. Prawns and octopus keep the pass busy.',
        dish:'GRILLED PRAWNS', desc:'Tiger prawns, spiced pepper paste, charred lemon. Five to a plate.'},
      {t:120, time:'1:00 AM',  state:'Last plates', title:'Last plates',
        sub:"One o'clock. Thursday takes its last order here. Friday and Saturday press on toward two.",
        dish:'BEEF TARTARE', desc:'Tenderloin, mac sauce, capers, shaved parmesan, chili oil.'},
      {t:180, time:'2:00 AM',  state:'Last call', title:'Last call',
        sub:"Two o'clock, Friday and Saturday. The last table is poured and the fire is finally allowed to rest.",
        dish:'PULPO', desc:'Grilled octopus, romesco, salsa verde, charred lemon.'}
    ];

    function setHand(el, deg){ if(el) el.setAttribute('transform','rotate('+deg.toFixed(2)+' 200 200)'); }

    function activeBeat(min){ var idx=0; for(var i=0;i<BEATS.length;i++){ if(min>=BEATS[i].t) idx=i; } return idx; }

    var lastIdx=-1;
    function pulse(){
      if(!hasGSAP||reduce) return;
      var halo=$('.clock-halo');
      if(halo){ gsap.killTweensOf(halo); gsap.fromTo(halo,{opacity:0.55,scale:0.96},{opacity:1,scale:1.04,duration:0.5,ease:'power2.out',yoyo:true,repeat:1}); }
      if(nowDot){
        gsap.killTweensOf(nowDot);
        gsap.fromTo(nowDot,{attr:{r:2.7}},{attr:{r:4.5},duration:0.6,ease:'elastic.out(1,0.4)'});
      }
      if(center){ gsap.fromTo(center,{opacity:0.4},{opacity:1,duration:0.5,ease:'power2.out'}); }
    }

    function render(p){
      p=clamp(p,0,1);
      var min=p*180;
      /* hands: hour sweeps 330deg -> 420deg (11 over 12,1 to 2); minute = (min%60)*6 */
      var hourDeg = 330 + (min/60)*30;
      var minDeg  = (min%60)*6;
      setHand(hour, hourDeg);
      setHand(minute, minDeg);
      /* arc reveal + rider dot */
      if(arc) arc.style.strokeDashoffset=(arcLen*(1-p)).toFixed(1);
      if(nowDot){
        var point=null;
        if(arc && arc.getPointAtLength){ try{ point=arc.getPointAtLength(arcLen*p); }catch(e){} }
        if(point){
          nowDot.setAttribute('cx',point.x.toFixed(1));
          nowDot.setAttribute('cy',point.y.toFixed(1));
        } else {
          var th=(330 + p*90)*Math.PI/180;
          nowDot.setAttribute('cx',(200+155*Math.sin(th)).toFixed(1));
          nowDot.setAttribute('cy',(200-155*Math.cos(th)).toFixed(1));
        }
      }
      if(elProg) elProg.style.transform='scaleX('+p+')';
      /* clock time label */
      var totalMin = 1380 + Math.round(min);           /* 23:00 baseline */
      var dd=new Date(); dd.setHours(0,0,0,0); dd.setMinutes(totalMin);
      if(elTime) elTime.textContent=fmt12(dd);
      /* room fill: fills up then eases toward last call */
      var full = Math.round(clamp(60 + Math.sin(p*Math.PI*0.85)*44, 0, 100));
      if(elFull) elFull.textContent=full+'%';
      if(elPlates) elPlates.textContent=pad(Math.round(lerp(0,47,p)));
      /* active beat */
      var idx=activeBeat(min);
      var b=BEATS[idx];
      if(elState) elState.textContent=b.state;
      marks.forEach(function(m){ var mt=parseInt(m.getAttribute('data-mark'),10); m.classList.toggle('on', mt<=min+0.5); });
      if(idx!==lastIdx){
        lastIdx=idx;
        if(elBeatTitle) elBeatTitle.textContent=b.title;
        if(elBeatSub) elBeatSub.textContent=b.sub;
        if(elDish) elDish.textContent=b.dish;
        if(elDishDesc) elDishDesc.textContent=b.desc;
        if(hasGSAP && !reduce){
          var beatTargets=[elBeatTitle,elBeatSub,elDish,elDishDesc].filter(Boolean);
          gsap.killTweensOf(beatTargets);
          gsap.fromTo(beatTargets,{opacity:0.35,y:8},{opacity:1,y:0,duration:0.38,stagger:0.035,ease:E.soft,overwrite:true});
        }
        if(center) center.textContent = (idx>=4?'LATE':'LATE');
        pulse();
      }
    }

    if(reduce || !hasGSAP || !hasST){ render(0); return; }

    var mm = gsap.matchMedia();
    mm.add('(min-width:980px)', function(){
      var st = ScrollTrigger.create({
        trigger:pin, start:'top top', end:'+=300%', pin:true, scrub:0.6, anticipatePin:1, invalidateOnRefresh:true,
        onUpdate:function(self){ render(self.progress); },
        onRefreshInit:function(){ render(0); }
      });
      render(0);
      return function(){ st.kill(true); };
    });
    mm.add('(max-width:979px)', function(){
      render(0);
      var trig = ScrollTrigger.create({
        trigger:pin,
        start:'top 78%',
        end:'bottom 60%',
        scrub:0.35,
        invalidateOnRefresh:true,
        onUpdate:function(self){ render(self.progress); },
        onRefreshInit:function(){ render(0); }
      });
      return function(){ trig.kill(true); };
    });
    return function(){ mm.revert(); };
  }

  /* ───── EMBERS HOLD · SET PIECE 2 (breathing coal bed) ───── */
  function initEmbers(root){
    var host=inRoot(root,'#embers'), cv=inRoot(root,'#embersCanvas');
    var elTemp=$('#emTemp'), elHold=$('#emHold'), elCount=$('#emCount'), elState=$('#emState');
    if(!host||!cv) return;
    var ctx=cv.getContext && cv.getContext('2d');
    if(!ctx) return;
    var dpr=Math.min(window.devicePixelRatio||1,2), coals=[], sparks=[], W=0, H=0, t=0;
    function size(){ var r=cv.getBoundingClientRect(); cv.width=Math.max(2,Math.round(r.width*dpr)); cv.height=Math.max(2,Math.round(r.height*dpr)); W=cv.width; H=cv.height; build(); }
    function build(){
      var n=clamp(Math.round(W/(30*dpr)),26,80); coals=[];
      for(var i=0;i<n;i++){
        coals.push({
          x:Math.random()*W,
          y:H - (Math.random()*Math.random())*H*0.42,
          r:(Math.random()*26+14)*dpr,
          phase:Math.random()*6.28,
          speed:Math.random()*0.5+0.28,
          base:Math.random()*0.4+0.28
        });
      }
    }
    function drawCoal(c, glow){
      var g=ctx.createRadialGradient(c.x,c.y,0,c.x,c.y,c.r);
      g.addColorStop(0,'rgba(255,255,255,'+(glow*0.6)+')');
      g.addColorStop(0.28,'rgba(138,95,58,'+glow+')');
      g.addColorStop(0.7,'rgba(74,51,31,'+(glow*0.5)+')');
      g.addColorStop(1,'rgba(36,26,17,0)');
      ctx.fillStyle=g; ctx.beginPath(); ctx.arc(c.x,c.y,c.r,0,6.2832); ctx.fill();
    }
    var start0=Date.now();
    function readouts(avg){
      if(elTemp) elTemp.innerHTML=Math.round(460+avg*120)+'&deg;C';
      if(elCount) elCount.textContent=coals.length + sparks.length;
      if(elState){ var s= avg<0.42?'holding':(avg<0.62?'breathing':'flaring'); if(elState.textContent!==s) elState.textContent=s; }
      if(elHold){ var mins=252 + Math.floor((Date.now()-start0)/60000); elHold.textContent=Math.floor(mins/60)+'h '+pad(mins%60)+'m'; }
    }
    if(reduce){
      size();
      ctx.clearRect(0,0,W,H);
      for(var i=0;i<coals.length;i++){ drawCoal(coals[i], coals[i].base+0.2); }
      readouts(0.42);
      return;
    }
    var run=false, acc=0;
    function frame(){ if(!run) return; t+=0.016;
      ctx.clearRect(0,0,W,H);
      var sum=0;
      for(var i=0;i<coals.length;i++){ var c=coals[i];
        var glow=c.base + 0.26*Math.sin(t*c.speed + c.phase) + 0.06*Math.sin(t*2.4 + c.phase*2);
        glow=clamp(glow,0.06,0.92); sum+=glow;
        drawCoal(c, glow);
        /* occasional spark rising off a bright coal */
        if(glow>0.7 && Math.random()<0.004){ sparks.push({x:c.x+(Math.random()-0.5)*c.r,y:c.y,vy:-(Math.random()*1.1+0.5)*dpr,vx:(Math.random()-0.5)*0.4*dpr,life:0,max:Math.random()*70+50,r:(Math.random()*1.2+0.5)*dpr}); }
      }
      for(var k=sparks.length-1;k>=0;k--){ var s=sparks[k]; s.life++; s.y+=s.vy; s.x+=s.vx; s.vy+=0.004*dpr;
        var f=1-clamp(s.life/s.max,0,1);
        if(f<=0){ sparks.splice(k,1); continue; }
        var sg=ctx.createRadialGradient(s.x,s.y,0,s.x,s.y,s.r*3);
        sg.addColorStop(0,'rgba(255,255,255,'+(f*0.9)+')'); sg.addColorStop(0.5,'rgba(138,95,58,'+(f*0.7)+')'); sg.addColorStop(1,'rgba(138,95,58,0)');
        ctx.fillStyle=sg; ctx.beginPath(); ctx.arc(s.x,s.y,s.r*3,0,6.2832); ctx.fill();
      }
      acc++;
      if(acc%18===0){ readouts(sum/Math.max(coals.length,1)); }
      requestAnimationFrame(frame);
    }
    function startA(){ if(run)return; run=true; requestAnimationFrame(frame); }
    function stopA(){ run=false; }
    size();
    var rt, io=null;
    function resize(){ clearTimeout(rt); rt=setTimeout(size,220); }
    window.addEventListener('resize', resize, {passive:true});
    if('IntersectionObserver' in window){ io=new IntersectionObserver(function(en){ en.forEach(function(e){ e.isIntersecting?startA():stopA(); }); },{threshold:0.02}); io.observe(cv); } else startA();
    return function(){ stopA(); clearTimeout(rt); window.removeEventListener('resize',resize); if(io) io.disconnect(); };
  }

  /* ───── HOURS · timeline fill + mark tonight ───── */
  function initHours(root){
    var cards=$$('#arcGrid .arc-card',root); if(!cards.length) return;
    var wd=new Date().getDay();
    cards.forEach(function(c){ if(parseInt(c.getAttribute('data-day'),10)===wd){ c.classList.add('live'); var w=$('[data-when]',c); if(w) w.textContent='Tonight'; } });
    var fills=$$('#arcGrid .arc-timeline i',root);
    if(hasGSAP && hasST && !reduce){
      fills.forEach(function(f){ var to=parseFloat(f.getAttribute('data-fill'))||0.9; gsap.to(f,{scaleX:to,duration:1.2,ease:E.ember,scrollTrigger:{trigger:f,start:'top 92%'}}); });
    } else {
      fills.forEach(function(f){ f.style.transform='scaleX('+(parseFloat(f.getAttribute('data-fill'))||0.9)+')'; });
    }
  }

  /* ───── TABLE CARD top bar sweep ───── */
  function initTableCard(root){
    var card=inRoot(root,'#tableCard'); if(!card) return;
    if(hasST && !reduce){
      ScrollTrigger.create({ trigger:card, start:'top 82%', once:true, onEnter:function(){ card.classList.add('swept'); } });
    } else {
      card.classList.add('swept');
    }
  }

  /* ───── FAQ ───── */
  function initFaq(root){
    $$('.faq-item',root).forEach(function(item){
      var q=$('.faq-q',item), a=$('.faq-a',item), inner=$('.faq-a-in',item);
      if(!q||!a) return;
      q.addEventListener('click', function(){
        var open=item.classList.contains('open');
        $$('.faq-item.open',root).forEach(function(o){ if(o!==item){ o.classList.remove('open'); var oa=$('.faq-a',o); if(hasGSAP&&!reduce) gsap.to(oa,{height:0,duration:0.4,ease:E.inOut}); else oa.style.height='0px'; } });
        if(open){ item.classList.remove('open'); if(hasGSAP&&!reduce) gsap.to(a,{height:0,duration:0.4,ease:E.inOut}); else a.style.height='0px'; }
        else { item.classList.add('open'); var h=inner.offsetHeight; if(hasGSAP&&!reduce) gsap.fromTo(a,{height:0},{height:h,duration:0.5,ease:E.soft,onComplete:function(){a.style.height='auto';}}); else a.style.height='auto'; }
      });
    });
  }

  /* ----- CORPORATE GALLERY LIGHTBOX ----- */
  function initCorporateGallery(root){
    var gallery=inRoot(root,'#corporate-gallery');
    if(!gallery) return;
    var triggers=$$('[data-gallery-open]',gallery);
    var lightbox=$('[data-gallery-lightbox]',gallery);
    if(!triggers.length||!lightbox) return;
    var lightboxHome=lightbox.parentNode;
    var lightboxNext=lightbox.nextSibling;
    document.body.appendChild(lightbox);
    var dialog=$('.corp-lightbox__dialog',lightbox);
    var image=$('[data-gallery-image]',lightbox);
    var imageButton=$('[data-gallery-zoom]',lightbox);
    var caption=$('[data-gallery-caption]',lightbox);
    var count=$('[data-gallery-count]',lightbox);
    var previous=$('[data-gallery-prev]',lightbox);
    var next=$('[data-gallery-next]',lightbox);
    var triggerHandlers=[];
    var activeIndex=0, lastFocus=null, hideTimer=null;

    function resetZoom(){
      imageButton.classList.remove('is-zoomed');
      imageButton.setAttribute('aria-pressed','false');
      imageButton.setAttribute('aria-label','Zoom image');
      image.style.transformOrigin='50% 50%';
    }
    function render(index){
      activeIndex=(index+triggers.length)%triggers.length;
      var trigger=triggers[activeIndex];
      resetZoom();
      image.src=trigger.getAttribute('data-gallery-src')||'';
      image.alt=trigger.getAttribute('data-gallery-alt')||'';
      caption.textContent=trigger.getAttribute('data-gallery-caption')||image.alt;
      count.textContent=pad(activeIndex+1)+' / '+pad(triggers.length);
      previous.hidden=triggers.length<2;
      next.hidden=triggers.length<2;
    }
    function lockPage(lock){
      document.body.classList.toggle('corp-lightbox-open',lock);
      if(window.__lenis){
        if(lock&&window.__lenis.stop) window.__lenis.stop();
        if(!lock&&window.__lenis.start) window.__lenis.start();
      }
    }
    function open(index,trigger){
      clearTimeout(hideTimer);
      lastFocus=trigger||document.activeElement;
      render(index);
      lightbox.hidden=false;
      lightbox.setAttribute('aria-hidden','false');
      lockPage(true);
      requestAnimationFrame(function(){ lightbox.classList.add('is-open'); if(dialog) dialog.focus(); });
    }
    function close(){
      if(lightbox.hidden) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden','true');
      lockPage(false);
      hideTimer=setTimeout(function(){ lightbox.hidden=true; image.removeAttribute('src'); },reduce?0:260);
      if(lastFocus&&lastFocus.focus){ try{ lastFocus.focus(); }catch(e){} }
    }
    function toggleZoom(event){
      var zoomed=!imageButton.classList.contains('is-zoomed');
      if(zoomed&&event){
        var rect=imageButton.getBoundingClientRect();
        var x=clamp(((event.clientX-rect.left)/rect.width)*100,0,100);
        var y=clamp(((event.clientY-rect.top)/rect.height)*100,0,100);
        image.style.transformOrigin=x+'% '+y+'%';
      }
      imageButton.classList.toggle('is-zoomed',zoomed);
      imageButton.setAttribute('aria-pressed',zoomed?'true':'false');
      imageButton.setAttribute('aria-label',zoomed?'Zoom image out':'Zoom image');
    }
    function onKeydown(event){
      if(lightbox.hidden) return;
      if(event.key==='Escape'){ event.preventDefault(); close(); }
      else if(event.key==='ArrowLeft'){ event.preventDefault(); render(activeIndex-1); }
      else if(event.key==='ArrowRight'){ event.preventDefault(); render(activeIndex+1); }
      else if(event.key==='Tab'&&dialog){
        var focusable=$$('button:not([disabled]):not([hidden])',dialog).filter(function(el){ return el.offsetParent!==null; });
        if(!focusable.length) return;
        var first=focusable[0], last=focusable[focusable.length-1];
        if(event.shiftKey&&document.activeElement===first){ event.preventDefault(); last.focus(); }
        else if(!event.shiftKey&&document.activeElement===last){ event.preventDefault(); first.focus(); }
      }
    }
    function onLightboxClick(event){
      if(event.target.closest&&event.target.closest('[data-gallery-close]')) close();
      else if(event.target.closest&&event.target.closest('[data-gallery-prev]')) render(activeIndex-1);
      else if(event.target.closest&&event.target.closest('[data-gallery-next]')) render(activeIndex+1);
    }
    triggers.forEach(function(trigger,index){
      var handler=function(){ open(index,trigger); };
      triggerHandlers.push(handler);
      trigger.addEventListener('click',handler);
    });
    imageButton.addEventListener('click',toggleZoom);
    lightbox.addEventListener('click',onLightboxClick);
    document.addEventListener('keydown',onKeydown);

    return function(){
      clearTimeout(hideTimer);
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden','true');
      lightbox.hidden=true;
      image.removeAttribute('src');
      lockPage(false);
      triggers.forEach(function(trigger,index){ trigger.removeEventListener('click',triggerHandlers[index]); });
      imageButton.removeEventListener('click',toggleZoom);
      lightbox.removeEventListener('click',onLightboxClick);
      document.removeEventListener('keydown',onKeydown);
      if(lightbox.parentNode) lightbox.parentNode.removeChild(lightbox);
      if(lightboxHome&&lightboxHome.isConnected){
        if(lightboxNext&&lightboxNext.parentNode===lightboxHome) lightboxHome.insertBefore(lightbox,lightboxNext);
        else lightboxHome.appendChild(lightbox);
      }
    };
  }

  /* ───── FOOTER · rising embers + wordmark ───── */
  function initFooter(root){
    var host=inRoot(root,'#footEmbers'), word=inRoot(root,'#footWord');
    if(host && !reduce && hasGSAP){
      for(var i=0;i<24;i++){ var e=document.createElement('span'); e.className='foot-ember'; e.style.left=(Math.random()*100)+'%'; host.appendChild(e);
        (function(el){ function fly(){ gsap.set(el,{opacity:0,y:0,x:0}); gsap.to(el,{opacity:lerp(0.3,0.8,Math.random()),duration:0.4,delay:Math.random()*3}); gsap.to(el,{y:-(120+Math.random()*220),x:(Math.random()-0.5)*80,opacity:0,duration:2.6+Math.random()*2.4,ease:'power1.out',delay:Math.random()*3,onComplete:fly}); } fly(); })(e);
      }
    }
    if(word && hasST && !reduce){
      ScrollTrigger.create({ trigger:inRoot(root,'#footer'), start:'top 74%', once:true, onEnter:function(){ gsap.fromTo(word,{opacity:0.5,scale:0.985,letterSpacing:'0.05em'},{opacity:1,scale:1,letterSpacing:'0.14em',duration:1.1,ease:E.reveal}); } });
      word.addEventListener('click', function(){ if(hasGSAP) gsap.fromTo(word,{textShadow:'0 0 0 rgba(138,95,58,0)'},{textShadow:'0 0 40px rgba(138,95,58,0.6)',duration:0.4,yoyo:true,repeat:1,ease:E.ember}); });
    }
  }

  /* ───── SCROLL PROGRESS BEAM ───── */
  function initProgress(){
    var fill=$('.beam i'); if(!fill) return;
    if(!hasST || reduce){
      function progress(){ var h=document.documentElement.scrollHeight-innerHeight; var p=h>0?(window.pageYOffset/h):0; fill.style.transform='scaleX('+p+')'; }
      window.addEventListener('scroll', progress, {passive:true}); progress();
      return function(){ window.removeEventListener('scroll',progress); };
    }
    gsap.to(fill, {scaleX:1, ease:'none', scrollTrigger:{ start:0, end:'max', scrub:0.3 }});
  }

  /* ───── SERVICE HUD zone ───── */
  function initHud(){
    var zone=$('#hudZone'); if(!zone || !hasST) return;
    var map=[['#hero','Corporate at ALIA'],['#corporate-gallery','Event gallery'],['#corporate','Event services'],['#table','The late table'],['#ways-in','Three ways in'],['#reserve','Plan your event'],['#choose-alia','Choose your way'],['#footer','Contact ALIA']];
    map.forEach(function(m){ var el=$(m[0]); if(!el) return; ScrollTrigger.create({ trigger:el, start:'top 55%', end:'bottom 55%', onToggle:function(self){ if(self.isActive) zone.textContent=m[1]; } }); });
  }

  /* ───── EASTER EGG · double-click hero holds a candle flare ───── */
  function initEgg(root){
    var h1=inRoot(root,'#heroH1'); if(!h1) return;
    h1.addEventListener('dblclick', function(){
      if(!hasGSAP||reduce) return;
      var f=document.createElement('div');
      f.style.cssText='position:fixed;inset:0;margin:auto;width:56vw;max-width:600px;aspect-ratio:1/1;transform:scale(0.3);pointer-events:none;z-index:9990;mix-blend-mode:screen;background:radial-gradient(circle,rgba(255,255,255,.82),rgba(138,95,58,.4) 34%,rgba(138,95,58,0) 66%)';
      document.body.appendChild(f);
      gsap.to(f,{scale:1.2,opacity:0,duration:1.1,ease:'power2.out',onComplete:function(){ f.remove(); }});
    });
  }

  /* ───── PARALLAX ambient ───── */
  function initParallax(root){
    if(!hasST || reduce) return;
    var glow=inRoot(root,'.reserve-glow'), reserve=inRoot(root,'#reserve');
    if(glow && reserve) gsap.to(glow, {yPercent:-18, ease:'none', scrollTrigger:{ trigger:reserve, start:'top bottom', end:'bottom top', scrub:1 }});
  }

  /* ───── SECTION LIFECYCLE + ONE GLOBAL LENIS ───── */
  function actionFromEvent(event){
    var path=event.composedPath?event.composedPath():[];
    if(!path.length){
      var node=event.target;
      while(node){ path.push(node); node=node.parentNode; }
    }
    for(var i=0;i<path.length;i++){
      if(path[i] && path[i].matches && path[i].matches('[data-act]')) return path[i];
    }
    return null;
  }

  function bindBookingActions(){
    if(window.__aliaBookingActionsBound) return;
    window.__aliaBookingActionsBound=true;
    document.addEventListener('click',function(event){
      var trigger=actionFromEvent(event);
      if(!trigger || trigger.getAttribute('data-act')!=='corp') return;
      var host=$('.alia-booking-widget');
      if(!host || !host.__aliaBookingWidget) return;
      event.preventDefault();
      host.__aliaBookingWidget.openModal(trigger);
    });
  }

  function initBookingWidget(root){
    var host=inRoot(root,'.alia-booking-widget');
    if(!host || !host.attachShadow) return;
    if(host.__aliaBookingCleanup){ try{ host.__aliaBookingCleanup(); }catch(e){} }
    var shadow=host.shadowRoot||host.attachShadow({mode:'open'});
    var config=window.ALIA_CFG||{};
    var endpoint=String(config.endpoint||'').trim();
    var restaurantUrl=host.getAttribute('data-restaurant-url')||'https://www.opentable.ca/r/alia-montreal';
    var clubUrl=host.getAttribute('data-club-url')||'tel:+15145662542';
    var phone=host.getAttribute('data-phone')||'(514) 566-2542';
    shadow.innerHTML=`
      <style>
        :host{--field-placeholder:rgba(238,237,227,.68);--field-surface:color-mix(in srgb,var(--roast-2,#4A331F) 64%,var(--roast,#241A11) 36%);--field-surface-hover:color-mix(in srgb,var(--roast-2,#4A331F) 78%,var(--bone,#EEEDE3) 22%);--field-rim:color-mix(in srgb,var(--amber,#8A5F3A) 78%,var(--bone,#EEEDE3) 22%);--form-gold:color-mix(in srgb,var(--amber,#8A5F3A) 68%,var(--bone,#EEEDE3) 32%);font-family:"Chivo",system-ui,-apple-system,sans-serif;color:var(--bone,#EEEDE3);color-scheme:dark}
        *,*::before,*::after{box-sizing:border-box}button,input,select,textarea{font:inherit}button,a{cursor:pointer}a{text-decoration:none}
        .shell{position:relative;z-index:10020;opacity:0;transform:translateY(12px);pointer-events:none;transition:opacity .35s var(--ease,cubic-bezier(.22,1,.36,1)),transform .35s var(--ease,cubic-bezier(.22,1,.36,1))}
        :host(.revealed) .shell{opacity:1;transform:none;pointer-events:auto}
        .fab{position:fixed;right:clamp(18px,3vw,30px);bottom:clamp(18px,3vw,30px);z-index:3;width:62px;height:62px;border:1px solid rgba(255,255,255,.34);border-radius:50%;background-color:var(--cta-green,#1FA35B);color:#fff;font-family:"Chivo Mono",ui-monospace,monospace;font-size:25px;line-height:1;box-shadow:0 14px 40px rgba(0,0,0,.42),0 0 0 7px rgba(31,163,91,.13);transition:background-color .3s,transform .35s var(--ease,cubic-bezier(.22,1,.36,1))}
        .fab:hover{background-color:var(--cta-green-dark,#17824A);transform:translateY(-2px)}
        .panel{position:fixed;right:clamp(18px,3vw,30px);bottom:clamp(94px,10vw,106px);z-index:2;width:min(350px,calc(100vw - 36px));padding:24px;border:1px solid rgba(31,163,91,.62);border-top:3px solid var(--cta-green,#1FA35B);border-radius:4px;background-color:var(--roast,#241A11);background-image:linear-gradient(155deg,rgba(31,163,91,.12),rgba(36,26,17,0) 58%);box-shadow:0 24px 70px rgba(0,0,0,.55);opacity:0;visibility:hidden;transform:translateY(16px) scale(.98);transform-origin:bottom right;transition:opacity .25s,visibility .25s,transform .3s var(--ease,cubic-bezier(.22,1,.36,1))}
        .panel.open{opacity:1;visibility:visible;transform:none}.panel-k{display:block;font-family:"Chivo Mono",ui-monospace,monospace;font-size:9px;letter-spacing:.22em;text-transform:uppercase;color:var(--cta-green,#1FA35B)}
        .panel h2{margin:8px 0 4px;font-size:22px;font-weight:300;line-height:1.1;text-transform:uppercase}.panel p{margin:0 0 18px;color:var(--mute,rgba(238,237,227,.6));font-size:13px}
        .panel-actions{display:grid;gap:8px}.action{display:flex;align-items:center;justify-content:space-between;gap:16px;width:100%;padding:14px 15px;border:1px solid var(--cta-green,#1FA35B);border-radius:2px;font-family:"Chivo Mono",ui-monospace,monospace;font-size:10px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;transition:background-color .25s,color .25s}
        .action span{font-size:8px;font-weight:400;opacity:.72}.action.primary{background-color:var(--cta-green,#1FA35B);color:#fff}.action.primary:hover{background-color:var(--cta-green-dark,#17824A)}.action.ghost{background-color:var(--roast,#241A11);color:var(--cta-green,#1FA35B)}.action.ghost:hover{background-color:var(--cta-green,#1FA35B);color:#fff}
        .phone{display:block;margin:17px 0 0;text-align:center;font-family:"Chivo Mono",ui-monospace,monospace;font-size:10px;letter-spacing:.12em;color:var(--mute,rgba(238,237,227,.6))}
        .overlay{position:fixed;inset:0;z-index:4;display:flex;align-items:flex-start;justify-content:center;padding:18px;overflow:auto;background:rgba(10,7,5,.86);backdrop-filter:blur(10px);opacity:0;visibility:hidden;transition:opacity .25s,visibility .25s}.overlay.open{opacity:1;visibility:visible}.overlay[hidden]{display:none}
        .modal{position:relative;width:min(660px,100%);margin:auto;border:1px solid var(--amber-line,rgba(138,95,58,.32));border-top:2px solid var(--cta-green,#1FA35B);border-radius:5px;background-color:color-mix(in srgb,var(--roast,#241A11) 82%,#000 18%);background-image:linear-gradient(145deg,rgba(74,51,31,.16),rgba(10,7,5,.12) 54%);box-shadow:0 30px 100px rgba(0,0,0,.72)}
        .modal-head{padding:26px 68px 20px 28px;border-bottom:1px solid var(--bone-line,rgba(238,237,227,.1))}.modal-k{font-family:"Chivo Mono",ui-monospace,monospace;font-size:10px;letter-spacing:.28em;text-transform:uppercase;color:var(--amber,#8A5F3A)}.modal h2{margin:6px 0;font-size:26px;font-weight:300;line-height:1.15;text-transform:uppercase}.modal-head p{margin:0;max-width:46ch;color:var(--mute,rgba(238,237,227,.6));font-size:14px;line-height:1.6}
        .close{position:absolute;top:18px;right:18px;width:38px;height:38px;border:1px solid var(--bone-line,rgba(238,237,227,.1));border-radius:3px;background:transparent;color:var(--bone,#EEEDE3);font-size:22px}.close:hover{border-color:var(--cta-green,#1FA35B);color:var(--cta-green,#1FA35B)}
        form{padding:24px 28px 28px}.grid{display:grid;grid-template-columns:1fr 1fr;gap:15px}.field{display:flex;min-width:0;flex-direction:column;gap:7px}.field.full{grid-column:1/-1}.field[hidden]{display:none}
        .field label{font-family:"Chivo Mono",ui-monospace,monospace;font-size:10px;font-weight:700;letter-spacing:.2em;text-transform:uppercase;color:var(--form-gold,#C9A45C)}.optional{color:color-mix(in srgb,var(--form-gold,#C9A45C) 58%,transparent)}
        .field input,.field select,.field textarea{width:100%;border:1px solid var(--field-rim,#7A6437);border-radius:4px;background-color:var(--field-surface,#3D3428);background-image:linear-gradient(180deg,rgba(255,255,255,.035),rgba(0,0,0,.035));color:var(--bone,#EEEDE3);padding:13px 14px;outline:none;font-size:16px;line-height:1.35;box-shadow:inset 0 1px 0 rgba(238,237,227,.08),0 4px 12px -8px rgba(0,0,0,.8);transition:background-color .18s,border-color .18s,box-shadow .18s}
        .field textarea{min-height:88px;resize:vertical;font-size:15px;line-height:1.55}.field input::placeholder,.field textarea::placeholder{color:var(--field-placeholder);opacity:1}.field select.is-empty,.field input[type="date"].is-empty{color:var(--field-placeholder)}.field select.is-empty:focus{color:var(--bone,#EEEDE3)}.field select option{color:var(--bone,#EEEDE3);background:var(--field-surface,#3D3428)}.field select option[value=""]{color:var(--field-placeholder)}
        .field input:hover,.field select:hover,.field textarea:hover{background-color:var(--field-surface-hover,#4A4031);border-color:var(--form-gold,#C9A45C)}
        .field input:focus,.field select:focus,.field textarea:focus{background-color:var(--field-surface-hover,#4A4031);border-color:var(--cta-green,#1FA35B);box-shadow:inset 0 0 0 1px var(--cta-green,#1FA35B),0 0 0 3px rgba(31,163,91,.2)}
        .form-foot{display:flex;align-items:center;justify-content:space-between;gap:16px;flex-wrap:wrap;margin-top:22px;padding-top:20px;border-top:1px solid var(--bone-line,rgba(238,237,227,.1))}.form-note{margin:0;max-width:34ch;color:var(--mute-2,rgba(238,237,227,.38));font-size:12px;line-height:1.5}.submit{flex:0 0 auto;border:1px solid var(--cta-green,#1FA35B);border-radius:4px;background:var(--cta-green,#1FA35B);color:#fff;padding:12px 18px;font-family:"Chivo Mono",ui-monospace,monospace;font-size:10px;font-weight:700;letter-spacing:.16em;text-transform:uppercase}.submit:hover{background:var(--cta-green-dark,#17824A)}.submit:disabled{cursor:wait;opacity:.65}.status{min-height:1.2em;margin:10px 0 0;color:#e3a899;font-size:12px}
        .modal.is-confirmation{width:min(560px,100%)}.confirm{padding:clamp(30px,5vw,44px);text-align:left}.confirm[hidden],.form-view[hidden],.send-again[hidden]{display:none}.confirm-top{display:flex;align-items:center;gap:14px;margin-bottom:24px}.confirm-mark{display:grid;flex:0 0 auto;width:46px;height:46px;place-items:center;border-radius:50%;background:var(--cta-green,#1FA35B);color:#fff;font-size:23px}.confirm-kicker{font-family:"Chivo Mono",ui-monospace,monospace;font-size:9px;font-weight:700;letter-spacing:.22em;text-transform:uppercase;color:var(--form-gold,#C9A45C)}.confirm.is-failure .confirm-mark{background:var(--amber,#8A5F3A)}.confirm h2{margin:0;font-size:clamp(27px,4vw,36px);font-weight:300;line-height:1.05;text-transform:uppercase}.confirm p{max-width:none;margin:20px 0 26px;padding:18px 20px;border:1px solid var(--field-rim,#7A6437);border-left:3px solid var(--cta-green,#1FA35B);border-radius:4px;background-color:var(--field-surface,#3D3428);color:var(--bone,#EEEDE3);font-size:14px;line-height:1.65}.confirm.is-failure p{border-left-color:var(--amber,#8A5F3A)}.confirm-actions{display:flex;flex-wrap:wrap;align-items:center;justify-content:flex-start;gap:12px}.send-again{border:1px solid var(--cta-green,#1FA35B);border-radius:4px;background:transparent;color:var(--cta-green,#1FA35B);padding:12px 16px;font-family:"Chivo Mono",ui-monospace,monospace;font-size:9px;font-weight:700;letter-spacing:.14em;text-transform:uppercase}.send-again:hover{background:var(--cta-green,#1FA35B);color:#fff}
        @media(max-width:620px){.overlay{padding:10px}.modal{margin:0}.grid{grid-template-columns:1fr;gap:13px}.field.full{grid-column:auto}.form-foot{align-items:stretch;flex-direction:column}.submit{width:100%}.modal-head{padding:18px 58px 15px 20px}.modal h2{font-size:22px}form{padding:18px 20px 22px}.close{top:14px;right:14px}.confirm{padding:26px 20px}.confirm-top{padding-right:44px;margin-bottom:20px}.confirm h2{font-size:27px}.confirm p{margin:17px 0 20px;padding:16px;font-size:13.5px}.confirm-actions{align-items:stretch;flex-direction:column}.confirm-actions button{width:100%}.fab{right:14px;bottom:max(14px,env(safe-area-inset-bottom));width:50px;height:50px;font-size:20px;box-shadow:0 10px 28px rgba(0,0,0,.42),0 0 0 5px rgba(31,163,91,.12)}.panel{right:14px;bottom:76px;width:min(330px,calc(100vw - 28px));padding:20px}}
        @media(prefers-reduced-motion:reduce){.shell,.fab,.panel,.overlay{transition:none}}
      </style>
      <div class="shell">
        <section class="panel" id="bookingPanel" aria-labelledby="panelTitle" aria-hidden="true">
          <span class="panel-k">Three ways in</span>
          <h2 id="panelTitle">Which one are you here for?</h2>
          <p>Choose an action and go there in one click.</p>
          <div class="panel-actions">
            <a class="action primary" id="widgetCorporate" data-act="corp">Corporate <span>Private events</span></a>
            <a class="action ghost" id="widgetRestaurant" data-act="restaurant" target="_blank" rel="noopener">Restaurant <span>OpenTable</span></a>
            <a class="action ghost" id="widgetClub" data-act="club">Club <span>Call</span></a>
          </div>
          <a class="phone" id="widgetPhone"></a>
        </section>
        <button class="fab" type="button" aria-label="Open ALIA booking options" aria-expanded="false" aria-controls="bookingPanel">?</button>
        <div class="overlay" id="corporateModal" hidden aria-hidden="true">
          <section class="modal" role="dialog" aria-modal="true" aria-labelledby="corporateTitle">
            <button class="close" type="button" aria-label="Close corporate enquiry">&times;</button>
            <div class="form-view">
              <header class="modal-head"><span class="modal-k">Private events</span><h2 id="corporateTitle">Request a date</h2><p>Share the details for your corporate or private event at ALIA.</p></header>
              <form id="corporateForm">
                <div class="grid">
                  <div class="field"><label for="corpName">Name</label><input id="corpName" name="Name" autocomplete="name" placeholder="Your name" required></div>
                  <div class="field"><label for="corpCompany">Company</label><input id="corpCompany" name="Company" autocomplete="organization" placeholder="Company name" required></div>
                  <div class="field"><label for="corpEmail">Work email</label><input id="corpEmail" name="Email" type="email" autocomplete="email" placeholder="name@company.com" required></div>
                  <div class="field"><label for="corpPhone">Phone</label><input id="corpPhone" name="Phone" type="tel" autocomplete="tel" placeholder="Phone number" required></div>
                  <div class="field"><label for="corpEvent">Event</label><select id="corpEvent" name="Event type" class="is-empty" required><option value="">Choose one</option><option>Corporate event</option><option>Client dinner</option><option>Private event</option><option>Product launch</option><option>Year-end event</option><option value="Something else">Something else</option></select></div>
                  <div class="field"><label for="corpGuests">Guests</label><input id="corpGuests" name="Guests" type="number" min="1" inputmode="numeric" placeholder="Estimated guests" required></div>
                  <div class="field full" id="otherEventField" hidden><label for="corpOther">Tell us about the event</label><input id="corpOther" name="Event detail" placeholder="Event type"></div>
                  <div class="field"><label for="corpDate">Preferred date</label><input id="corpDate" name="Preferred date" type="date" class="is-empty" required></div>
                  <div class="field"><label for="corpBudget">Budget per head <span class="optional">(optional)</span></label><select id="corpBudget" name="Budget per head" class="is-empty"><option value="">Not sure yet</option><option>$95 to $150</option><option>$150 to $225</option><option>$225 and up</option></select></div>
                  <div class="field full"><label for="corpNotes">Notes <span class="optional">(optional)</span></label><textarea id="corpNotes" name="Notes" placeholder="Anything ALIA should know"></textarea></div>
                </div>
                <div class="form-foot"><p class="form-note"></p><button class="submit" type="submit">Send request</button></div>
                <p class="status" role="alert" aria-live="polite"></p>
              </form>
            </div>
            <div class="confirm" hidden><div class="confirm-top"><span class="confirm-mark" aria-hidden="true">&#10003;</span><span class="confirm-kicker">Private events</span></div><h2>Request prepared</h2><p class="confirm-summary"></p><div class="confirm-actions"><button class="submit confirm-close" type="button">Close</button><button class="send-again" type="button" hidden>Send another request</button></div></div>
          </section>
        </div>
      </div>`;

    var panel=shadow.querySelector('.panel'), fab=shadow.querySelector('.fab');
    var modal=shadow.querySelector('.modal');
    var overlay=shadow.querySelector('.overlay'), close=shadow.querySelector('.close');
    var form=shadow.querySelector('form'), formView=shadow.querySelector('.form-view');
    var confirm=shadow.querySelector('.confirm'), confirmClose=shadow.querySelector('.confirm-close');
    var sendAgain=shadow.querySelector('.send-again');
    var confirmSummary=shadow.querySelector('.confirm-summary'), status=shadow.querySelector('.status');
    var submit=form.querySelector('.submit'), eventSelect=shadow.querySelector('#corpEvent');
    var budgetSelect=shadow.querySelector('#corpBudget');
    var otherField=shadow.querySelector('#otherEventField'), otherInput=shadow.querySelector('#corpOther');
    var dateInput=shadow.querySelector('#corpDate'), lastFocus=null, hideTimer=null;
    shadow.querySelector('#widgetCorporate').href='/#corporate';
    shadow.querySelector('#widgetRestaurant').href=restaurantUrl;
    shadow.querySelector('#widgetClub').href=clubUrl;
    shadow.querySelector('#widgetPhone').href=clubUrl;
    shadow.querySelector('#widgetPhone').textContent=phone;
    shadow.querySelector('.form-note').textContent=endpoint?'Your request will be added to the shared corporate lead sheet.':'Online submission is awaiting its secure Google Sheets endpoint.';

    function setPanel(open){
      panel.classList.toggle('open',open);
      panel.setAttribute('aria-hidden',open?'false':'true');
      fab.setAttribute('aria-expanded',open?'true':'false');
      fab.setAttribute('aria-label',open?'Close ALIA booking options':'Open ALIA booking options');
      fab.textContent=open?'×':'?';
    }
    function lockScroll(lock){
      document.body.classList.toggle('alia-modal-open',lock);
      if(window.__lenis){
        if(lock && window.__lenis.stop) window.__lenis.stop();
        if(!lock && window.__lenis.start) window.__lenis.start();
      }
    }
    var sentKey='alia-private-event-sent:'+(config.domain||location.hostname);
    function readSent(){
      try{ return JSON.parse(sessionStorage.getItem(sentKey)||'null'); }
      catch(e){ return null; }
    }
    function rememberSent(payload){
      try{ sessionStorage.setItem(sentKey,JSON.stringify(payload)); }
      catch(e){}
    }
    function forgetSent(){
      try{ sessionStorage.removeItem(sentKey); }
      catch(e){}
    }
    function openModal(trigger){
      clearTimeout(hideTimer);
      dateState();
      lastFocus=trigger||document.activeElement;
      setPanel(false);
      var prior=readSent();
      if(prior) showConfirmation(prior,true,true);
      else { modal.classList.remove('is-confirmation'); formView.hidden=false; confirm.hidden=true; }
      overlay.hidden=false;
      overlay.setAttribute('aria-hidden','false');
      lockScroll(true);
      requestAnimationFrame(function(){
        overlay.classList.add('open');
        var first=prior?confirmClose:shadow.querySelector('#corpName');
        if(first) first.focus();
      });
    }
    function closeModal(){
      overlay.classList.remove('open');
      overlay.setAttribute('aria-hidden','true');
      lockScroll(false);
      hideTimer=setTimeout(function(){ overlay.hidden=true; },reduce?0:260);
      if(lastFocus && lastFocus.focus){ try{ lastFocus.focus(); }catch(e){} }
    }
    function getTodayString(){
      var now=new Date();
      var year=now.getFullYear();
      var month=String(now.getMonth()+1).padStart(2,'0');
      var day=String(now.getDate()).padStart(2,'0');
      return year+'-'+month+'-'+day;
    }
    function toggleOther(){
      var show=eventSelect.value==='Something else';
      eventSelect.classList.toggle('is-empty',eventSelect.value==='');
      otherField.hidden=!show;
      otherInput.required=show;
      if(!show) otherInput.value='';
    }
    function dateState(){
      var today=getTodayString();
      dateInput.min=today;
      if(dateInput.value && dateInput.value<today){
        dateInput.value='';
        dateInput.setCustomValidity('Please select today or a future date.');
      } else {
        dateInput.setCustomValidity('');
      }
      dateInput.classList.toggle('is-empty',dateInput.value==='');
    }
    function budgetState(){ budgetSelect.classList.toggle('is-empty',budgetSelect.value===''); }
    function payloadFromForm(){
      var payload={};
      Array.prototype.forEach.call(form.elements,function(field){
        if(!field.name) return;
        var value=String(field.value||'').trim();
        if(!value) return;
        payload[field.name]=value;
      });
      payload.Site=String(config.site||'').trim();
      payload.Page=location.href;
      return payload;
    }
    function eventName(payload){ return payload['Event type']==='Something else'?(payload['Event detail']||'Event'):payload['Event type']; }
    function displayDate(value){
      if(!value) return 'the requested date';
      try{
        var parts=value.split('-');
        return new Date(Number(parts[0]),Number(parts[1])-1,Number(parts[2])).toLocaleDateString('en-CA',{year:'numeric',month:'long',day:'numeric'});
      }catch(e){ return value; }
    }
    function showConfirmation(payload,delivered,returning){
      modal.classList.add('is-confirmation');
      formView.hidden=true;
      confirm.hidden=false;
      confirm.classList.toggle('is-failure',!delivered);
      sendAgain.hidden=!returning;
      shadow.querySelector('.confirm-mark').textContent=delivered?'✓':'!';
      shadow.querySelector('.confirm h2').textContent=returning?'Already sent':(delivered?'Request received':'Please call ALIA');
      confirmSummary.textContent=returning
        ? payload.Name+', we already have your '+eventName(payload).toLowerCase()+' enquiry for '+displayDate(payload['Preferred date'])+' and '+payload.Guests+' guests on file.'
        : delivered
        ? payload.Name+', your '+eventName(payload).toLowerCase()+' enquiry for '+displayDate(payload['Preferred date'])+' and '+payload.Guests+' guests has been submitted to ALIA. The contact details are '+payload.Email+' and '+payload.Phone+'.'
        : 'We could not submit this automatically. Please call '+phone+' with your preferred date and guest count.';
      confirmClose.focus();
    }
    function onSendAgain(){
      forgetSent();
      form.reset();
      status.textContent='';
      toggleOther();
      dateState();
      budgetState();
      modal.classList.remove('is-confirmation');
      confirm.hidden=true;
      formView.hidden=false;
      if(endpoint){ submit.disabled=false; submit.textContent='Send request'; }
      shadow.querySelector('#corpName').focus();
    }
    function onSubmit(event){
      event.preventDefault();
      status.textContent='';
      if(!form.checkValidity()){ form.reportValidity(); return; }
      var payload=payloadFromForm();
      if(!endpoint){ status.textContent='Online submission is not connected yet. Please call '+phone+'.'; return; }
      submit.disabled=true;
      submit.textContent='Sending…';
      fetch(endpoint,{method:'POST',headers:{'Content-Type':'text/plain;charset=utf-8'},body:JSON.stringify(payload)})
        .then(function(){ rememberSent(payload); showConfirmation(payload,true,false); })
        .catch(function(){ showConfirmation(payload,false); })
        .then(function(){ submit.disabled=false; submit.textContent='Send request'; });
    }
    if(!endpoint){ submit.disabled=true; submit.textContent='Endpoint pending'; }
    function onFab(){ setPanel(!panel.classList.contains('open')); }
    function onShadowClick(event){
      var action=actionFromEvent(event);
      if(action && action.getAttribute('data-act')!=='corp') setPanel(false);
      if(event.target===overlay) closeModal();
    }
    function onKeydown(event){
      if(event.key==='Escape'){
        if(!overlay.hidden) closeModal(); else setPanel(false);
      }
      if(event.key==='Tab' && !overlay.hidden){
        var focusable=Array.prototype.slice.call(shadow.querySelectorAll('.overlay button:not([disabled]),.overlay input:not([disabled]),.overlay select:not([disabled]),.overlay textarea:not([disabled])')).filter(function(el){ return !el.closest('[hidden]'); });
        if(!focusable.length) return;
        var first=focusable[0], last=focusable[focusable.length-1];
        if(event.shiftKey && shadow.activeElement===first){ event.preventDefault(); last.focus(); }
        else if(!event.shiftKey && shadow.activeElement===last){ event.preventDefault(); first.focus(); }
      }
    }
    fab.addEventListener('click',onFab);
    close.addEventListener('click',closeModal);
    confirmClose.addEventListener('click',closeModal);
    sendAgain.addEventListener('click',onSendAgain);
    shadow.addEventListener('click',onShadowClick);
    shadow.addEventListener('keydown',onKeydown);
    eventSelect.addEventListener('change',toggleOther);
    dateInput.addEventListener('change',dateState);
    dateInput.addEventListener('input',dateState);
    budgetSelect.addEventListener('change',budgetState);
    form.addEventListener('submit',onSubmit);
    toggleOther(); dateState(); budgetState();
    host.__aliaBookingWidget={openModal:openModal,closeModal:closeModal};

    function cleanup(){
      clearTimeout(hideTimer);
      lockScroll(false);
      fab.removeEventListener('click',onFab);
      close.removeEventListener('click',closeModal);
      confirmClose.removeEventListener('click',closeModal);
      sendAgain.removeEventListener('click',onSendAgain);
      shadow.removeEventListener('click',onShadowClick);
      shadow.removeEventListener('keydown',onKeydown);
      eventSelect.removeEventListener('change',toggleOther);
      dateInput.removeEventListener('change',dateState);
      dateInput.removeEventListener('input',dateState);
      budgetSelect.removeEventListener('change',budgetState);
      form.removeEventListener('submit',onSubmit);
      delete host.__aliaBookingWidget;
      delete host.__aliaBookingCleanup;
    }
    host.__aliaBookingCleanup=cleanup;
    return cleanup;
  }

  function initDock(root){
    var dock=inRoot(root,'.alia-booking-widget'); if(!dock) return;
    var interval=null, timeout=null;
    function reveal(){ dock.classList.add('revealed'); }
    if(window.__lateSeatingBooted){ reveal(); return; }
    var selector='#preloader,#intro,#introStatement,[id*="preload" i],[class*="preloader" i],[class*="intro-idx"],[class*="intro-col"],[class*="intro-grid"],.intro-statement,.d-veil,.hero-veil,.tex-veil,.pre-veil,[class*="veil"]';
    var start=Date.now();
    interval=setInterval(function(){
      var el=document.querySelector(selector), gone=!el;
      if(el){ var cs=getComputedStyle(el); gone=(cs.display==='none'||cs.visibility==='hidden'||parseFloat(cs.opacity)<0.1); }
      if(gone || (Date.now()-start)>6000){ reveal(); clearInterval(interval); interval=null; }
    },200);
    timeout=setTimeout(reveal,6200);
    return function(){ if(interval) clearInterval(interval); if(timeout) clearTimeout(timeout); };
  }

  function destroySection(root){
    var key=typeof root==='string'?root:sectionKey(root);
    var record=sectionRegistry[key]; if(!record) return;
    record.cleanups.slice().reverse().forEach(function(cleanup){ try{ cleanup(); }catch(e){} });
    record.triggers.forEach(function(trigger){ try{ trigger.kill(true); }catch(e){} });
    if(record.context){ try{ record.context.revert(); }catch(e){} }
    if(hasGSAP && record.root){
      var targets=[record.root].concat($$('*',record.root));
      try{ gsap.killTweensOf(targets); }catch(e){}
    }
    delete sectionRegistry[key];
  }

  function initSection(root){
    if(!root) return;
    var key=sectionKey(root), cleanups=[];
    destroySection(key);
    var before=hasST?ScrollTrigger.getAll().slice():[];
    function run(){
      bindCursor(root);
      bindAnchors(root);
      initReveals(root);
      initHeadlines(root);
      if(inRoot(root,'.cursor')) addCleanup(cleanups,initCursor(root));
      if(inRoot(root,'#nav')) addCleanup(cleanups,initNav(root));
      if(inRoot(root,'#hero')){
        heroIntro(root);
        addCleanup(cleanups,initHeroCanvas(root));
        addCleanup(cleanups,initKitchen(root));
        initEgg(root);
      }
      if(inRoot(root,'#clock')) addCleanup(cleanups,initClock(root));
      if(inRoot(root,'#embers')) addCleanup(cleanups,initEmbers(root));
      if(inRoot(root,'#hours')) initHours(root);
      if(inRoot(root,'#table')) initTableCard(root);
      if(inRoot(root,'#faq')) initFaq(root);
      if(inRoot(root,'#corporate-gallery')) addCleanup(cleanups,initCorporateGallery(root));
      if(inRoot(root,'#footer')) initFooter(root);
      if(inRoot(root,'#reserve')) initParallax(root);
      if(inRoot(root,'.alia-booking-widget')){
        addCleanup(cleanups,initBookingWidget(root));
        addCleanup(cleanups,initDock(root));
      }
    }
    var context=null;
    if(hasGSAP){ context=gsap.context(run,root); } else { run(); }
    var triggers=hasST?ScrollTrigger.getAll().filter(function(trigger){ return before.indexOf(trigger)===-1; }):[];
    sectionRegistry[key]={root:root,cleanups:cleanups,triggers:triggers,context:context};
  }

  function clearCrossSection(){
    crossTriggers.forEach(function(trigger){ try{ trigger.kill(true); }catch(e){} });
    crossTriggers=[];
    if(crossContext){ try{ crossContext.revert(); }catch(e){} crossContext=null; }
    if(window.__lateSeatingCrossCleanup){ try{ window.__lateSeatingCrossCleanup(); }catch(e){} window.__lateSeatingCrossCleanup=null; }
  }

  function rebuildCrossSection(){
    clearCrossSection();
    var cleanups=[], before=hasST?ScrollTrigger.getAll().slice():[];
    function run(){ addCleanup(cleanups,initProgress()); initHud(); }
    if(hasGSAP) crossContext=gsap.context(run,document.body); else run();
    crossTriggers=hasST?ScrollTrigger.getAll().filter(function(trigger){ return before.indexOf(trigger)===-1; }):[];
    window.__lateSeatingCrossCleanup=function(){ cleanups.forEach(function(cleanup){ try{ cleanup(); }catch(e){} }); };
  }

  function sectionRoots(){
    var roots=$$('.shopify-section');
    return roots.length?roots:[document.body];
  }

  function initGlobalScroll(){
    if(window.__lateSeatingLenis || window.__lateSeatingScrollReady) return;
    window.__lateSeatingScrollReady=true;
    var lenis=null;
    if(window.Lenis && hasGSAP && hasST && !reduce && !isTouch){
      try{
        lenis=new Lenis({lerp:0.1,wheelMultiplier:1,smoothWheel:true});
        lenis.on('scroll',function(e){ ScrollTrigger.update(); vel=e.velocity||0; window.__vel=vel; });
        window.__lateSeatingTicker=function(t){ lenis.raf(t*1000); };
        gsap.ticker.add(window.__lateSeatingTicker);
        gsap.ticker.lagSmoothing(0);
        window.__lenis=lenis;
        window.__lateSeatingLenis=lenis;
      }catch(e){ lenis=null; }
    }
    if(!lenis){
      var lastY=window.pageYOffset;
      window.addEventListener('scroll',function(){ var y=window.pageYOffset; window.__vel=(y-lastY); lastY=y; },{passive:true});
    }
  }

  function boot(){
    if(appBooted) return;
    appBooted=true;
    window.__lateSeatingBooted=true;
    initGlobalScroll();
    bindBookingActions();
    sectionRoots().forEach(initSection);
    rebuildCrossSection();
    if(hasST){
      ScrollTrigger.refresh();
      if(document.fonts && document.fonts.ready){ document.fonts.ready.then(function(){ ScrollTrigger.refresh(); }); }
      setTimeout(function(){ ScrollTrigger.refresh(); },800);
    }
  }

  document.addEventListener('shopify:section:load',function(event){
    if(!appBooted) return;
    var root=event.target;
    var pre=inRoot(root,'#preloader'); if(pre && pre.parentNode) pre.remove();
    initSection(root);
    requestAnimationFrame(function(){ rebuildCrossSection(); if(hasST) ScrollTrigger.refresh(); });
  });
  document.addEventListener('shopify:section:unload',function(event){
    destroySection(event.target);
    requestAnimationFrame(function(){ rebuildCrossSection(); if(hasST) ScrollTrigger.refresh(); });
  });
  document.addEventListener('shopify:section:reorder',function(){
    requestAnimationFrame(function(){ rebuildCrossSection(); if(hasST) ScrollTrigger.refresh(); });
  });

  function start(){ runPreloader(boot); }
  if(document.readyState==='complete') start();
  else window.addEventListener('load',start,{once:true});
})();
